/**
 * Procedure Categories and Procedures for MD in Nuclear Medicine students
 * Extracted with strict evidence from official NMC PDF
 */
export const NUCLEAR_MEDICINE_MD_PROCEDURES = {
  "Diagnostic In-Vivo & Hybrid Imaging Procedures": [
    "Esophageal Transit Time Measurement",
    "Gastric Emptying Time Study",
    "Renal Transplant Evaluation Study",
    "Ejection Fraction (EF) and Regional Wall Motion Abnormality (RWMA) Determination",
    "SPECT/CT & PET/CT Scan Acquisition, Processing, and Image Reconstruction",
    "PET/MRI Hybrid Scan Performance & Post-Processing",
  ],
  "Diagnostic In-Vitro & Radioimmunoassay Procedures": [
    "Glomerular Filtration Rate (GFR) Estimation",
    "Radioactive Iodine Uptake (RAIU) Measurements",
    "Red Cell Mass & Red Cell Survival Study",
    "C-14 Urea Breath Test",
    "Radioimmunoassay (RIA) & Immunoradiometric Assay (IRMA)",
  ],
  "Targeted Radionuclide Therapy": [
    "Radioiodine (I-131) Therapy for Hyperthyroidism & Thyroid Cancer",
    "177Lu-PRRT (Peptide Receptor Radionuclide Therapy for Neuroendocrine Tumors)",
    "177Lu-PSMA Therapy for Prostate Cancer",
    "Radionuclide Bone Pain Palliation Therapy (P32, Sr89, Sm153, Ra223, Lu177)",
    "Radiosynovectomy",
    "Radioimmunotherapy & Locoregional Radiation Therapy",
  ],
};

export const NUCLEAR_MEDICINE_MD_CATEGORIES = Object.keys(NUCLEAR_MEDICINE_MD_PROCEDURES);

export const isMDInNuclearMedicineDept = (department) => {
  if (!department) {
    try {
      const u = JSON.parse(
        localStorage.getItem("userData") || localStorage.getItem("user") || "{}"
      );
      department = u.department || (u.departments && u.departments[0]);
    } catch (e) {}
  }
  if (!department) return false;
  const d = String(department).toLowerCase();
  return (
    (d.includes("md") || d.includes("master")) &&
    (d.includes("nuclear medicine") || d.includes("nuclear"))
  );
};
